import type { ReactNode } from 'react'
import TuneRoundedIcon from '@mui/icons-material/TuneRounded'
import { Button } from './Button'

export interface SettingsLinkChipProps {
  label: ReactNode
  onClick?: () => void
  className?: string
  testId?: string
}

/**
 * SettingsLinkChip (SR13)
 * Compact tertiary button with Tune icon for pages that link to their settings home.
 */
export function SettingsLinkChip({
  label,
  onClick,
  className,
  testId,
}: SettingsLinkChipProps) {
  return (
    <Button
      variant="tertiary"
      size="sm"
      className={['skLinkChip', className].filter(Boolean).join(' ')}
      icon={<TuneRoundedIcon fontSize="inherit" />}
      onClick={onClick}
      data-testid={testId}
    >
      {label}
    </Button>
  )
}
